/*jshint esversion: 6 */

jQuery( function ( $ ) {

	/* MACHINE SELECTOR */
	// Open/close toggle.
	$('a#machine').on('click ready', function() {
		$('body').addClass('mp-popup-open');
		$('.my-machines__overlay').addClass('hidden');
		setTimeout(function() {
			$('.mp-close-btn').on('click ready', function() {
				$('body').removeClass('mp-popup-open');
				$('.my-machines__overlay').removeClass('hidden');
			});
			$(document).on('keyup', function(e) {
				if (e.key == "Escape") {
					$('body').removeClass('mp-popup-open');
					$('.my-machines__overlay').removeClass('hidden');
				}
			});
		}, 500);
	});

	$('a.product-details-toggle').on('click ready', function() {

		$('span', this).text( function( i, text ) {
			return text === "Vis detaljert info" ? "Skjul detaljert info" : "Vis detaljert info";
		});

		$(this).next('div').toggleClass('hidden');
		$(this).find('i').toggleClass('icon-angle-up').toggleClass('icon-angle-down');
	});

	// Mark selected machine for styling.
	$('#choose-machine > .mp-lists ul').on('change', 'li > label > input', function() {
		$(this).closest('ul').find('li').removeClass('selected');
		$(this).closest('li').addClass('selected');
		$('.mp-lists').addClass('changed');
	});

	/**
	 * PRODUCT ARCHIVE / CATEGORY PAGES
	 */
	if ( $('body').hasClass('woocommerce') && $('body').hasClass('archive') ) {

		$('input#bookmark_machine.bookmarked, a.close-favorite-machines-popup, .my-machines__overlay').on('click ready', function(e) {
			e.preventDefault();
			$('.my-machines__button').click();
		});

		$('.my-machines__button').on('click ready', function(e) {
			$('i', this).toggleClass('hidden');
			$('.my-machines__overlay').toggleClass('hidden');
		});

		$('.my-machines__overlay').on('click ready', function(e) {
			$('i', this).toggleClass('hidden');
			$('').toggleClass('hidden');
		});

		/* PRODUCT CATEGORY MENU */
		// Menu items more/less toggle.
		$('.category-menu ul.children').each( function() {
			var index = 4;
			if ( $(this).children('li').length > 6 ) {
				$(this).children('li:gt('+index+')').hide();
				$(this).append('<li class="more">Se flere</li>');
				$(this).children('li.more').on('click ready', function(e) {
					var text = $(this).text() == 'Se flere' ? 'Se færre' : 'Se flere';
					$(this).text(text).toggleClass("active");
					$(this).siblings('li:not(.more):gt('+index+')').slideToggle();
				});
			}
		});
		// Add accordion toggle chevron.
		$('.category-menu ul:not(.children) > li > a:not(:only-child)').each( function() {
			$(this).after('<a class="accordion-toggle"><i class="icon-angle-down"></i></a>');
		});
		// Add accordion toggle chevron click event.
		$('.accordion-toggle').on('click ready', function(e) {
			e.stopImmediatePropagation();
			e.preventDefault();
			var toggleIcon = $(this).find('i');
			if ( toggleIcon.hasClass('icon-angle-down') ) {
				toggleIcon.removeClass('icon-angle-down').addClass('icon-angle-up');
				$(this).siblings('ul.children').css( 'height', 'auto' );
			} else {
				toggleIcon.removeClass('icon-angle-up').addClass('icon-angle-down');
				$(this).siblings('ul.children').css( 'height', 0 );
			}
		});
	}
});

/**
 * Filters & sorting
 */

const closeFilterDropdown = (excludedElement = null) => {
	document.querySelectorAll('.wpc-filter-title > button').forEach(element => {
		if (excludedElement === element) {
			return;
		}
		const filterSection = element.closest('.wpc-filters-section');
		filterSection.classList.remove('wpc-opened');
		filterSection.classList.add('wpc-closed');
	});
}

const closeSortingDropdown = () => {
	document.querySelectorAll('.wc-sorting-toggle').forEach(toggle => {
		toggle.classList.remove('active');
	});
}

// Change the select element "wpc-orderby-select" to enable styling, allowing it to resemble a dropdown menu.
const changeOrderBySelectSize = () => {
	document.querySelectorAll('.wpc-orderby-select').forEach(selectElement => {
		selectElement.setAttribute('size', selectElement.options.length);
	});
}

const showNonEmptyFilters = () => {
	if (document.querySelectorAll('.wpc-filters-section:not(.inactive):not(.wpc-filter-layout-submit-button)').length <= 2) {
		return;
	}
	document.querySelectorAll('.wc-filters-toggle').forEach(filterToggle => {
		filterToggle.style.display = 'block';
	});
}

const hideEmptyFilters = () => {
	jQuery('.wpc-filters-section .wpc-filters-ul-list li:contains("There are no terms yet"), .wpc-filters-section .wpc-filters-ul-list li:contains("N/A")').closest('.wpc-filters-section').addClass('inactive');
}

const setSearchFilterFocus = () => {
	const searchFilterInput = document.querySelector('.wpc-search-field');
	if (!searchFilterInput) {
		return;
	}
	searchFilterInput.focus();
	searchFilterInput.setSelectionRange(searchFilterInput.value.length, searchFilterInput.value.length);
}

// Show a WooCommerce blocking overlay with an animated spinner.
const showSpinner = () => {
	jQuery('.shop-container').block({
		message: null,
		overlayCSS: {
			background: "#fff",
			opacity: .6
		}
	});
}

const hideSpinner = () => {
	jQuery.LoadingOverlay('hide');
}

const initializeDynamicContent = () => {
	// Close the loading overlay when the last AJAX call is completed.
	// This fix addresses the issue of the overlay not closing when navigating back to the page by clicking the back button.
	hideSpinner();

	closeFilterDropdown();
	closeSortingDropdown();

	// showNonEmptyFilters();
	hideEmptyFilters();

	changeOrderBySelectSize();

	// `.wc-sort-filter` markup lives in the webcodeno_wc_pnprosjekt plugin
	// (Webcodeno_WC_PNProsjekt_Public::render_sort_filter_section) and is not
	// rendered on every WC archive (search results, empty categories, etc.).
	// Guard the access so the rest of initializeDynamicContent still runs
	// when the element is missing.
	const wcSortFilter = document.querySelector('.wc-sort-filter');
	if (wcSortFilter) {
		wcSortFilter.style.visibility = '';
	}

	// Toggle filters on click.
	document.querySelectorAll('.wpc-filter-title > button').forEach(filterElement => {
		filterElement.addEventListener('click', event => {
			event.preventDefault();
			closeFilterDropdown(filterElement);
			closeSortingDropdown();
		});
	});

	// Hide all filters when clicked outside the filter area.
	// document.addEventListener('click', event => {
	// 	['.wc-sorting-toggle', '.wc-filters-toggle'].forEach(dropdownSelector => {
	// 		const dropdownSelectorClass = dropdownSelector.replace(/^(\.+)/g, '');
	// 		if (event.target.classList.contains(dropdownSelectorClass)) {
	// 			return;
	// 		}
	// 		if (event.target.closest('.wc-filters-content')) {
	// 			return;
	// 		}
	// 		closeFilterDropdown();
	// 		closeSortingDropdown();
	// 	});
	// });

	// Create a new Event.
	const changeEvent = new Event('change', {
		bubbles: true,
		cancelable: true
	});

	// Add a search function to filter products on the category page.
	var searchProductsTimeout = null;

	document.querySelectorAll('.wpc-search-field').forEach(element => {
		element.addEventListener('input', (event) => {
			clearTimeout(searchProductsTimeout);
			searchProductsTimeout = setTimeout(() => {
				element.dispatchEvent(changeEvent);
			}, 500);
		});
	});
}

document.addEventListener('DOMContentLoaded', () => {
	// Show the loading overlay while redirecting to the machine selector search results.
	document.querySelectorAll('.product-assignment-list-series input[type="submit"]').forEach(submitButton => {
		submitButton.addEventListener('click', () => {
			jQuery.LoadingOverlay('show', {
				zIndex: 9999
			});
		});
	});

	if (!document.body.matches('.woocommerce.archive')) {
		return;
	}

	// Toggle sorting on click.
	document.querySelectorAll('.wc-sort-filter > a').forEach(filterElement => {
		filterElement.addEventListener('click', event => {
			event.preventDefault();
			closeFilterDropdown();
			const isActive = event.target.classList.contains('active');
			document.querySelectorAll('.wc-sort-filter > a').forEach(filter => {
				filter.classList.remove('active');
			});
			if (!isActive) {
				event.target.classList.add('active');
			}
		});
	});

	const urlParams = new URLSearchParams(new URL(window.location.href).search);

	initializeDynamicContent();

	if (urlParams.has('srch')) {
		setSearchFilterFocus();
	}

	jQuery(document).ajaxComplete((ajaxComplete) => {
		initializeDynamicContent();

		if (!ajaxComplete.delegateTarget.activeElement.classList.contains('dgwt-wcas-search-input')) {
			setSearchFilterFocus();
		}
	});
});
